import React, { useEffect } from 'react'
import './componentsCss/ListCardAgreements.css'
import Avatar from '../assets/img/clients-im.svg'
import api from '../api'
import Loading from './Loading'
import Globals from '../Globals'
import { Link } from 'react-router-dom'
import './componentsCss/ListCardShoppers.css'
import Verification from '../assets/img/marca-de-verificacao.png'

function ListCardsCustomers({ search }) {
    const [data, setData] = React.useState([])

    const [loading, setLoading] = React.useState(false)
    const [page, setPage] = React.useState(1)
    const [finalPage, setFinalPage] = React.useState(null)

    const handleScroll = (event) => {
        if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 90 && !loading && !(page - 1 === finalPage)) {
            getData()
        }
    }

    const getData = (exception = false, page2 = null) => {

        if (((page > finalPage && finalPage !== null) || loading) && exception === false) {
            // Já carregamos todas as páginas disponíveis ou esta carregando
            return;
        }

        setLoading(true)

        if (search !== "") {
            api.get('/api/customers/search/' + search + '?page=' + String(page2 === null ? page : page2)).then((response) => {
                var customers = response.data.data
                for (const key in customers) {
                    customers[key].mobile = customers[key].mobile === null ? '' : customers[key].mobile.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3 - $4")
                    customers[key].cpf = customers[key].cpf === null ? '' : customers[key].cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
                }

                setData(page2 === null ? data.concat(response.data.data) : response.data.data)
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching shoppers:', error);
            }).finally(() => {
                setLoading(false)
            })

        } else {

            api.get('/api/customers?page=' + String(page)).then((response) => {
                var customers = response.data.data
                for (const key in customers) {
                    customers[key].mobile = customers[key].mobile === null ? '' : customers[key].mobile.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3 - $4")
                    customers[key].cpf = customers[key].cpf === null ? '' : customers[key].cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
                }
                setData(data.concat(response.data.data))
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching agreements:', error);
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        if (search === "") {
            setFinalPage(null)
            setPage(1)
            setData([])
            getData()

        } else {
            getData(true, 1)
        }
    }, [search])

    useEffect(() => {

        var el = document.getElementsByClassName('scroll-list-container')[0]

        if (el.scrollHeight <= window.innerHeight) {
            getData()
        }

    }, [page])


    return (
        <div onScroll={handleScroll} className='container-scroll'>
            <div className="row row-subcontainer scroll-list-container">

                {
                    data.length > 0 ? data.map((item, index) => {
                        return <Link className='col-12 col-sm-6 col-md-6 col-lg-4' style={{ padding: '0px 10px' }} key={index} to={'/customers/' + item.id}>
                            <div className='card-list-shopper'>

                                <div style={{position:'relative'}} className='col-3'>
                                    {
                                        item.verified === 1 ? <img className='verified-icon' src={Verification}/> : <></>
                                    }
                                    {
                                        item.image === "" || item.image === null || item.image === undefined ? <div className='avatar-img' >
                                            <img alt='avatar' src={Avatar} />
                                        </div> : <div style={{ background: 'url(' + Globals.BASE_URL + '/storage/' + item.image + ')  0% 0% / cover', }} alt='customers' className='card-list-agreements-img' ></div>
                                    }
                                </div>
                                <div className='col-9'>
                                    <span className='card-list-shopper-name'>{item.name}</span>
                                    <span className='card-list-shopper-cnpj_cpf'>{item.cpf}</span>
                                    <span className='card-list-shopper-mobile'>{item.mobile}</span>
                                </div>
                            </div>
                        </Link>
                    })
                        : !loading ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Pacientes</h6></div> : console.info("loading")
                }
                { }
                {loading ? <Loading /> : <></>}
            </div>
        </div>

    )
}

export default ListCardsCustomers;